import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { Card } from "primereact/card";
import { useDispatch, useSelector } from "react-redux";
import React, { useRef, useState } from "react";


function ErrorBlock() {
  const history = useHistory();
  let pFlag = false;
  let aFlag = false;
  let fFlag = false;
  let bFlag = false;
  let oFlag = false;
  let mFlag = false;
  let dFlag = false;
  let boFlag = false;
  let gFlag = false;
  let cFlag = false;
  let dirFlag = false;
  const personDetailErrors = useSelector(
    (state) => state.personalDetails.errors
  );

  const addressDetailErrors = useSelector(
    (state) => state.addressDetails.errors
  );
  const familyDetailErrors = useSelector((state) => state.familyDetails.errors);
  const bankDetailErrors = useSelector((state) => state.bankDetails.errors);
  const occupationDetailErrors = useSelector(
    (state) => state.occupationDetails.errors
  );
  const moneyLaunderingDetailsErrors = useSelector(
    (state) => state.moneyLaunderingDetails.errors
  );
  const documentDetailErrors = useSelector(
    (state) => state.documentDetails.errors
  );
  const boidDetailErrors = useSelector((state) => state.boidDetails.errors);
  const guardianDetailsErrors = useSelector(
    (state) => state.guardianDetails.errors
  );
  const errorDynamicFieldList = useSelector((state) => {
    return (
      state.dynamicFieldDetails.allDynamicField &&
      Object.values(state.dynamicFieldDetails.allDynamicField).filter(
        (d) => d.errorDesc
      )
    );
  });
  const companyDetailErrors = useSelector(
    (state) => state.companyDetails.errors
  );
  const directorDetailErrors = useSelector(
    (state) => state.directorDetails.errors
  );
  const errorList = useSelector((state) => state.lookupDetails.errorList);

  if (
    !personDetailErrors ||
    !Object.values(personDetailErrors).find((v) => v && v.message)
  )
    pFlag = true;
  if (
    !addressDetailErrors ||
    !Object.values(addressDetailErrors).find((v) => v && v.message)
  )
    aFlag = true;
  if (
    !familyDetailErrors ||
    !Object.values(familyDetailErrors).find((v) => v && v.message)
  )
    fFlag = true;
  if (
    !bankDetailErrors ||
    !Object.values(bankDetailErrors).find((v) => v && v.message)
  )
    bFlag = true;
  if (
    !occupationDetailErrors ||
    !Object.values(occupationDetailErrors).find((v) => v && v.message)
  )
    oFlag = true;

  if (
    !moneyLaunderingDetailsErrors ||
    !Object.values(moneyLaunderingDetailsErrors).find((v) => v && v.message)
  )
    mFlag = true;
  if (
    !documentDetailErrors ||
    !Object.values(documentDetailErrors).find((v) => v && v.message)
  )
    dFlag = true;
  if (
    !boidDetailErrors ||
    !Object.values(boidDetailErrors).find((v) => v && v.message)
  )
    boFlag = true;
  if (
    !guardianDetailsErrors ||
    !Object.values(guardianDetailsErrors).find((v) => v && v.message)
  )
    gFlag = true;
  if (
    !companyDetailErrors ||
    !Object.values(companyDetailErrors).find((v) => v && v.message)
  )
    cFlag = true;
  if (
    !directorDetailErrors ||
    !Object.values(directorDetailErrors).find((v) => v && v.message)
  )
    dirFlag = true;

  const sectionList = useSelector((state) => state.routerData.sectionList);
  const getRoute = (sectionCd) => {
    return sectionList.find(
      (section) => section.code === sectionCd || section.id === sectionCd
    ).route;
  };
  return (
    <>


      {(!pFlag ||
        !aFlag ||
        !fFlag ||
        !bFlag ||
        !oFlag ||
        !dFlag ||
        !boFlag ||
        !gFlag ||
        !cFlag ||
        !dirFlag) && (
          <div className="p-field p-col-12 p-md-12 p-grid ">
            <Card
              className="boxshadowRed p-pt-3 p-pb-3"
              style={{
                background: "#FFF",
                margin: "0px auto",
                color: "#e22528",
                width: "95%",
              }}
            >
              <p
                id="errorDiv"
                style={{ fontWeight: "bold", textAlign: "center" }}
              >
                Incomplete Required Information
              </p>
              <ul className="requiredInfo">
                {!pFlag && personDetailErrors && (
                  <>
                    <p
                      id="errorDiv"
                      style={{ fontWeight: "bold", textAlign: "center" }}
                    >
                      Incomplete Required Information (Person Details)
                    </p>
                    <div className="p-field p-col-12 p-md-12 p-grid ">
                      <ul className="requiredInfo">
                        {personDetailErrors &&
                          Object.values(personDetailErrors)
                            .filter((err) => err && err.message != null)
                            .map((err) => (
                              <div className="p-col-12 p-md-12">
                                <>
                                  {err.message} &nbsp;&nbsp;
                                  {err.message && (
                                    <i
                                      className="pi pi-eye"
                                      style={{ cursor: "pointer" }}
                                      onClick={() => {
                                        history.push(getRoute(err.section));
                                      }}
                                    />
                                  )}
                                </>
                              </div>
                            ))}
                      </ul>
                    </div>
                  </>
                )}
                {!cFlag && companyDetailErrors && (
                  <>
                    <p
                      id="errorDiv"
                      style={{ fontWeight: "bold", textAlign: "center" }}
                    >
                      Incomplete Required Information (Company Details)
                    </p>
                    <div className="p-field p-col-12 p-md-12 p-grid ">
                      <ul className="requiredInfo">
                        {companyDetailErrors &&
                          Object.values(companyDetailErrors)
                            .filter((err) => err && err.message != null)
                            .map((err) => (
                              <div className="p-col-12 p-md-12">
                                <>
                                  {err.message} &nbsp;&nbsp;
                                  {err.message && (
                                    <i
                                      className="pi pi-eye"
                                      style={{ cursor: "pointer" }}
                                      onClick={() => {
                                        history.push(getRoute(err.section));
                                      }}
                                    />
                                  )}
                                </>
                              </div>
                            ))}
                      </ul>
                    </div>
                  </>
                )}
                {!aFlag && addressDetailErrors && (
                  <>
                    <p
                      id="errorDiv"
                      style={{ fontWeight: "bold", textAlign: "center" }}
                    >
                      Incomplete Required Information (Address Details)
                    </p>
                    <div className="p-field p-col-12 p-md-12 p-grid ">
                      <ul className="requiredInfo">
                        {addressDetailErrors &&
                          Object.values(addressDetailErrors)
                            .filter((err) => err && err.message != null)
                            .map((err) => (
                              <div className="p-col-12 p-md-12">
                                <>
                                  {err.message} &nbsp;&nbsp;
                                  {err.message && (
                                    <i
                                      className="pi pi-eye"
                                      style={{ cursor: "pointer" }}
                                      onClick={() => {
                                        history.push(getRoute(err.section));
                                      }}
                                    />
                                  )}
                                </>
                              </div>
                            ))}
                      </ul>
                    </div>
                  </>
                )}
                {!fFlag && familyDetailErrors && (
                  <>
                    <p
                      id="errorDiv"
                      style={{ fontWeight: "bold", textAlign: "center" }}
                    >
                      Incomplete Required Information (Family Details)
                    </p>
                    <div className="p-field p-col-12 p-md-12 p-grid ">
                      <ul className="requiredInfo">
                        {familyDetailErrors &&
                          Object.values(familyDetailErrors)
                            .filter((err) => err && err.message != null)
                            .map((err) => (
                              <div>
                                <>
                                  {err.message} &nbsp;&nbsp;
                                  {err.message && (
                                    <i
                                      className="pi pi-eye"
                                      style={{ cursor: "pointer" }}
                                      onClick={() => {
                                        history.push(getRoute(err.section));
                                      }}
                                    />
                                  )}
                                </>
                              </div>
                            ))}
                      </ul>
                    </div>
                  </>
                )}

                {!bFlag && bankDetailErrors && (
                  <>
                    <p
                      id="errorDiv"
                      style={{ fontWeight: "bold", textAlign: "center" }}
                    >
                      Incomplete Required Information (Bank Details)
                    </p>
                    <div className="p-field p-col-12 p-md-12 p-grid ">
                      <ul className="requiredInfo">
                        {bankDetailErrors &&
                          Object.values(bankDetailErrors)
                            .filter((err) => err && err.message != null)
                            .map((err) => (
                              <div>
                                <>
                                  {err.message} &nbsp;&nbsp;
                                  {err.message && (
                                    <i
                                      className="pi pi-eye"
                                      style={{ cursor: "pointer" }}
                                      onClick={() => {
                                        history.push(getRoute(err.section));
                                      }}
                                    />
                                  )}
                                </>
                              </div>
                            ))}
                      </ul>
                    </div>
                  </>
                )}

                {!oFlag && occupationDetailErrors && (
                  <>
                    <p
                      id="errorDiv"
                      style={{ fontWeight: "bold", textAlign: "center" }}
                    >
                      Incomplete Required Information (Occupation Details)
                    </p>
                    <div className="p-field p-col-12 p-md-12 p-grid ">
                      <ul className="requiredInfo">
                        {occupationDetailErrors &&
                          Object.values(occupationDetailErrors)
                            .filter((err) => err && err.message != null)
                            .map((err) => (
                              <div>
                                <>
                                  {err.message} &nbsp;&nbsp;
                                  {err.message && (
                                    <i
                                      className="pi pi-eye"
                                      style={{ cursor: "pointer" }}
                                      onClick={() => {
                                        history.push(getRoute(err.section));
                                      }}
                                    />
                                  )}
                                </>
                              </div>
                            ))}
                      </ul>
                    </div>
                  </>
                )}

                {!mFlag && moneyLaunderingDetailsErrors && (
                  <>
                    <p
                      id="errorDiv"
                      style={{ fontWeight: "bold", textAlign: "center" }}
                    >
                      Incomplete Required Information (Money Laundering Declaration Details)
                    </p>
                    <div className="p-field p-col-12 p-md-12 p-grid ">
                      <ul className="requiredInfo">
                        {moneyLaunderingDetailsErrors &&
                          Object.values(moneyLaunderingDetailsErrors)
                            .filter((err) => err && err.message != null)
                            .map((err) => (
                              <div>
                                <>
                                  {err.message} &nbsp;&nbsp;
                                  {err.message && (
                                    <i
                                      className="pi pi-eye"
                                      style={{ cursor: "pointer" }}
                                      onClick={() => {
                                        history.push(getRoute(err.section));
                                      }}
                                    />
                                  )}
                                </>
                              </div>
                            ))}
                      </ul>
                    </div>
                  </>
                )}
                {!dFlag && documentDetailErrors && (
                  <>
                    <p
                      id="errorDiv"
                      style={{ fontWeight: "bold", textAlign: "center" }}
                    >
                      Incomplete Required Information (Document Details)
                    </p>
                    <div className="p-field p-col-12 p-md-12 p-grid ">
                      <ul className="requiredInfo">
                        {documentDetailErrors &&
                          Object.values(documentDetailErrors)

                            .filter((err) => err && err.message != null)
                            .map((err) => (
                              <div>
                                <>
                                  {err.message} &nbsp;&nbsp;
                                  {err.message && (
                                    <i
                                      className="pi pi-eye"
                                      style={{ cursor: "pointer" }}
                                      onClick={() => {
                                        history.push(getRoute(err.section));
                                      }}
                                    />
                                  )}
                                </>
                              </div>
                            ))}
                      </ul>
                    </div>
                  </>
                )}

                {!boFlag && boidDetailErrors && (
                  <>
                    <p
                      id="errorDiv"
                      style={{ fontWeight: "bold", textAlign: "center" }}
                    >
                      Incomplete Required Information (Boid Details)
                    </p>
                    <div className="p-field p-col-12 p-md-12 p-grid ">
                      <ul className="requiredInfo">
                        {boidDetailErrors &&
                          Object.values(boidDetailErrors)
                            .filter((err) => err && err.message != null)
                            .map((err) => (
                              <div>
                                <>
                                  {err.message} &nbsp;&nbsp;
                                  {err.message && (
                                    <i
                                      className="pi pi-eye"
                                      style={{ cursor: "pointer" }}
                                      onClick={() => {
                                        history.push(getRoute(err.section));
                                      }}
                                    />
                                  )}
                                </>
                              </div>
                            ))}
                      </ul>
                    </div>
                  </>
                )}
                {!gFlag && guardianDetailsErrors && (
                  <>
                    <p
                      id="errorDiv"
                      style={{ fontWeight: "bold", textAlign: "center" }}
                    >
                      Incomplete Required Information (Guardian Details)
                    </p>
                    <div className="p-field p-col-12 p-md-12 p-grid ">
                      <ul className="requiredInfo">
                        {guardianDetailsErrors &&
                          Object.values(guardianDetailsErrors)
                            .filter((err) => err && err.message != null)
                            .map((err) => (
                              <div>
                                <>
                                  {err.message} &nbsp;&nbsp;
                                  {err.message && (
                                    <i
                                      className="pi pi-eye"
                                      style={{ cursor: "pointer" }}
                                      onClick={() => {
                                        history.push(getRoute(err.section));
                                      }}
                                    />
                                  )}
                                </>
                              </div>
                            ))}
                      </ul>
                    </div>
                  </>
                )}

                {!dirFlag && directorDetailErrors && (
                  <>
                    {" "}
                    <p
                      id="errorDiv"
                      style={{ fontWeight: "bold", textAlign: "center" }}
                    >
                      Incomplete Required Information (Director Details)
                    </p>
                    <div className="p-field p-col-12 p-md-12 p-grid ">
                      <ul className="requiredInfo">
                        {directorDetailErrors &&
                          Object.values(directorDetailErrors)
                            .filter((err) => err && err.message != null)
                            .map((err) => (
                              <div className="p-col-12 p-md-12">
                                <>
                                  {err.message} &nbsp;&nbsp;
                                  {err.message && (
                                    <i
                                      className="pi pi-eye"
                                      style={{ cursor: "pointer" }}
                                      onClick={() => {
                                        history.push(getRoute(err.section));
                                      }}
                                    />
                                  )}
                                </>
                              </div>
                            ))}
                      </ul>
                    </div>
                  </>
                )}
                {errorDynamicFieldList && errorDynamicFieldList.length !== 0 && (
                  <>
                    <p
                      id="errorDiv"
                      style={{ fontWeight: "bold", textAlign: "center" }}
                    >
                      Other Incomplete Required Information
                    </p>
                    <div className="p-field p-col-12 p-md-12 p-grid ">
                      <ul className="requiredInfo">
                        {errorDynamicFieldList.map((dfield) => (
                          <div>
                            <>
                              {dfield.label} {dfield.errorDesc}
                              <i
                                className="pi pi-eye"
                                style={{ cursor: "pointer" }}
                                onClick={() => {
                                  history.push(getRoute(dfield.sectionId));
                                }}
                              />
                            </>
                          </div>
                        ))}
                      </ul>
                    </div>
                  </>
                )}
              </ul>
            </Card>
          </div>
        )}
    </>
  );
}
export default ErrorBlock;
